import { Flex } from 'antd';
import React, { memo } from 'react'
import { TailSpin } from 'react-loader-spinner';

type Props = {
  size?: number;
  className?: string;
  justify?: React.CSSProperties['justifyContent'];
}

function AppLoader({ size = 80, className = "py-3", justify = "center" }: Props) {
  return (
    <Flex justify={justify} className={className}>
      <TailSpin
        height={size}
        width={size}
        color="#677ab1"
        radius="1"
      />
    </Flex>
  )
}

export default memo(AppLoader);